import React from 'react';
// Falls ihr Next.js nutzt, importiere Head: import Head from 'next/head';
// Falls ihr React nutzt, nutze react-helmet für SEO Meta-Tags.

const Gespraechsraum = () => {
  return (
    <>
      {/* --- SEO & META TAGS --- */}
      {/* <Head>
        <title>Gesprächsraum | Systemisches Coaching & Konfliktlösung | Frequenz 741</title>
        <meta name="description" content="Der Frequenz 741 Gesprächsraum bietet einen geschützten, wertfreien Ort für ehrliche Gespräche, Paarberatung und neue Perspektiven. Auf Augenhöhe und vertraulich." />
        <meta name="keywords" content="Gesprächsraum, Systemisches Coaching, Konfliktlösung, Paarberatung, Perspektivenwechsel, Frequenz 741" />
        <link rel="canonical" href="https://frequenz741.de/gespraechsraum" />
      </Head>
      */}

      <main className="bg-[#FCFDFD] text-gray-800 font-sans leading-relaxed selection:bg-emerald-200 selection:text-emerald-900">
        
        {/* --- HERO SECTION --- */}
        <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-full bg-emerald-900/5 z-0"></div>
          <div className="max-w-6xl mx-auto px-6 relative z-10 text-center">
            <span className="text-emerald-700 font-semibold tracking-widest uppercase mb-4 block text-sm lg:text-base">
              Ihre Frequenz. Ihr Bewusstsein. Ihre Veränderung.
            </span>
            <h1 className="text-5xl md:text-7xl font-light text-gray-900 mb-8 leading-tight tracking-tight">
              Frequenz 741 <br />
              <span className="font-bold text-emerald-800">Gesprächsraum</span>
            </h1>
            <p className="text-2xl md:text-3xl text-gray-600 italic max-w-4xl mx-auto font-light leading-snug">
              Ein geschützter Ort für ehrliche Gespräche, neue Perspektiven und tiefe Klarheit im Miteinander.
            </p>
          </div>
        </section>

        {/* --- EINLEITUNG & PHILOSOPHIE --- */}
        <section className="max-w-4xl mx-auto px-6 py-20">
          <article className="prose prose-lg md:prose-xl prose-emerald mx-auto text-gray-700 leading-loose">
            <p className="text-xl md:text-2xl text-gray-900 font-medium text-center mb-12">
              Manchmal braucht es einfach einen geschützten Raum, um das auszusprechen, was im hektischen Alltag keinen Platz findet.
            </p>
            <p className="text-center">
              Ob als Paar oder allein – im Gesprächsraum von Frequenz 741 geht es nicht um Richtig oder Falsch. Es geht um das pure Mensch-Sein. Wir schaffen eine wertfreie Atmosphäre, in der Sie gehört werden, Ihre Gedanken sortieren und festgefahrene Muster durchbrechen können.
            </p>
            <p  className="text-center">
              Basierend auf unserer tiefen Verbundenheit zur Natur und unserem Ansatz des <strong>Systemischen Coachings</strong>, hören wir aktiv zu, stellen die richtigen Fragen und geben gezielte Impulse. Wir begleiten Sie auf einer Reise, auf der Sie Herausforderungen meistern und wieder in eine echte Verbindung kommen – mit sich selbst und miteinander.
            </p>
          </article>
        </section>

        {/* --- ZIELGRUPPE (FEATURE CARDS FÜR BESSERE UX/SEO) --- */}
        <section className="bg-emerald-50 py-24">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-emerald-900 mb-4">Für wen ist der Gesprächsraum?</h2>
              <p className="text-lg text-emerald-700">Unser Angebot richtet sich an Menschen, die aktiv etwas verändern möchten:</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Card 1 */}
              <div className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-emerald-100/50">
                <div className="w-14 h-14 bg-emerald-100 text-emerald-700 rounded-full flex items-center justify-center mb-6">
                  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path></svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Klarheit in der Beziehung</h3>
                <p className="text-gray-600">Sie wünschen sich wieder mehr Verständnis, Nähe und eine gemeinsame Ausrichtung für die Zukunft.</p>
              </div>

              {/* Card 2 */}
              <div className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-emerald-100/50">
                <div className="w-14 h-14 bg-emerald-100 text-emerald-700 rounded-full flex items-center justify-center mb-6">
                  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"></path></svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Neue Perspektiven</h3>
                <p className="text-gray-600">Sie stecken in einer beruflichen oder privaten Situation fest und suchen nach Wegen, den Geist wieder für Lösungen zu öffnen.</p>
              </div>

              {/* Card 3 */}
              <div className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-emerald-100/50">
                <div className="w-14 h-14 bg-emerald-100 text-emerald-700 rounded-full flex items-center justify-center mb-6">
                  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path></svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Konflikte nachhaltig lösen</h3>
                <p className="text-gray-600">Sie möchten unausgesprochene oder eskalierende Konflikte besser verstehen und konstruktiv aus der Welt schaffen.</p>
              </div>

              {/* Card 4 */}
              <div className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-emerald-100/50">
                <div className="w-14 h-14 bg-emerald-100 text-emerald-700 rounded-full flex items-center justify-center mb-6">
                  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path></svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Neutrales Zuhören</h3>
                <p className="text-gray-600">Sie brauchen einfach jemanden, der wertfrei und empathisch zuhört, um den eigenen emotionalen Kompass neu zu justieren.</p>
              </div>
            </div>
          </div>
        </section>

        {/* --- ABGRENZUNG / TRANSPARENZ --- */}
        <section className="max-w-4xl mx-auto px-6 py-20">
          <div className="border-l-4 border-emerald-300 pl-6 py-3 text-gray-600 bg-white rounded-r-xl shadow-sm">
            <h4 className="font-bold text-gray-900 mb-2 text-lg">Wichtiger Hinweis</h4>
            <p>
              Der Gesprächsraum ist keine therapeutische Einrichtung und ersetzt keine psychologische Therapie. Er ist ein offenes, wertfreies Coaching-Angebot für alle, die ihre Lebenssituation reflektieren und aktiv gestalten möchten.
            </p>
          </div>
        </section>

        {/* --- FULL WIDTH CALL TO ACTION (Passend zum Footer der Hauptseite) --- */}
        <section className="bg-emerald-900 text-white text-center py-24 px-6 relative overflow-hidden">
          {/* Dezentes Hintergrundmuster für mehr Tiefe */}
          <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent"></div>
          
          <div className="max-w-4xl mx-auto relative z-10">
            <p className="text-xl md:text-2xl font-light mb-6 text-emerald-100 tracking-wide uppercase">
              Vertraulich. Persönlich. Auf Augenhöhe.
            </p>
            <h2 className="text-4xl md:text-5xl font-bold mb-14 leading-tight">
              Frequenz 741 – weil gute Gespräche <br className="hidden md:block" /> den Unterschied machen.
            </h2>
            
            <div className="flex flex-col sm:flex-row justify-center items-center gap-6">
              <a 
                href="mailto:info@frequenz741.de" 
                className="group inline-flex items-center justify-center bg-white text-emerald-900 hover:bg-emerald-50 font-bold py-5 px-10 rounded-lg transition-all duration-300 shadow-xl text-lg w-full sm:w-auto"
                aria-label="Schreiben Sie uns eine E-Mail an info@frequenz741.de"
              >
                Jetzt Termin vereinbaren 
                <span className="ml-3 transform group-hover:translate-x-1 transition-transform duration-200">→</span>
              </a>
              
              <a 
                href="tel:+491723570148" 
                className="inline-flex items-center justify-center bg-transparent border-2 border-emerald-100/30 text-white hover:bg-emerald-800 hover:border-emerald-100 font-semibold py-5 px-10 rounded-lg transition-all duration-300 text-lg w-full sm:w-auto"
                aria-label="Rufen Sie uns an unter +49 172 3570148"
              >
                <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
                +49 172 3570148
              </a>
            </div>
          </div>
        </section>

      </main>
    </>
  );
};

export default Gespraechsraum;